import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mall-my-list" }
const _hoisted_2 = {
  key: 0,
  class: "mall-my-list__empty"
}
const _hoisted_3 = {
  key: 1,
  class: "mall-my-list__empty"
}
const _hoisted_4 = {
  key: 2,
  class: "mall-my-list__empty"
}
const _hoisted_5 = {
  key: 3,
  class: "mall-my-list__cards"
}
const _hoisted_6 = { class: "mall-my-list__meta" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 0,
  class: "mall-my-list__order"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "mall-my-list__title" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  class: "mall-my-list__reply"
}
const _hoisted_14 = { class: "mall-my-list__actions" }

import { onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { fetchMyReviews, type SellerMallReview } from '@/api/mallReview'
import { mallProductPath, MALL_ORDERS_PATH } from '@/constants/mall'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallMyReviewsPage',
  setup(__props) {

const loading = ref(true)
const errorMessage = ref('')
const reviews = ref<SellerMallReview[]>([])

async function loadReviews() {
  loading.value = true
  errorMessage.value = ''
  try {
    reviews.value = await fetchMyReviews()
  } catch (error) {
    reviews.value = []
    errorMessage.value = error instanceof Error ? error.message : '구매후기를 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  void loadReviews()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("header", { class: "mall-my-list__head" }, [
      _createElementVNode("h1", null, "구매후기"),
      _createElementVNode("p", null, "내가 작성한 상품 구매후기를 확인합니다.")
    ], -1)),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "불러오는 중입니다…"))
      : (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AppIcon, {
              icon: "mdi-alert-outline",
              size: 48
            }),
            _createElementVNode("p", null, _toDisplayString(errorMessage.value), 1),
            _createElementVNode("button", {
              type: "button",
              class: "mall-my-list__action-btn",
              onClick: loadReviews
            }, "다시 시도")
          ]))
        : (!reviews.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(AppIcon, {
                icon: "mdi-message-text-outline",
                size: 48
              }),
              _cache[1] || (_cache[1] = _createElementVNode("p", null, "작성한 구매후기가 없습니다.", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("em", null, "배송완료·구매확정 후 상품상세에서 구매후기를 남길 수 있습니다.", -1)),
              _createVNode(_component_router_link, { to: _unref(MALL_ORDERS_PATH) }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("주문내역 보기", -1)
                ]))]),
                _: 1
              }, 8, ["to"])
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviews.value, (review) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: review.idx
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("strong", null, "★ " + _toDisplayString(review.rating), 1),
                    _createElementVNode("time", null, _toDisplayString(review.date), 1)
                  ]),
                  _createVNode(_component_router_link, {
                    to: _unref(mallProductPath)(review.productCode),
                    class: "mall-my-list__product"
                  }, {
                    default: _withCtx(() => [
                      (review.productImage)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: review.productImage,
                            alt: review.productName
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(review.productName), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (review.orderCode)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                        _createVNode(_component_router_link, {
                          to: `/mall/orders/${encodeURIComponent(review.orderCode)}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 관련 주문 " + _toDisplayString(review.orderCode), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        (review.orderAt)
                          ? (_openBlock(), _createElementBlock("em", _hoisted_9, " · " + _toDisplayString(String(review.orderAt).slice(0, 10)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(review.content), 1),
                  (review.image)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: review.image,
                        class: "mall-my-list__photo",
                        target: "_blank",
                        rel: "noopener"
                      }, [
                        _createElementVNode("img", {
                          src: review.image,
                          alt: "구매후기 사진"
                        }, null, 8, _hoisted_12)
                      ], 8, _hoisted_11))
                    : _createCommentVNode("", true),
                  (review.reply)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                        _cache[3] || (_cache[3] = _createElementVNode("b", null, "판매자 답변", -1)),
                        _createTextVNode(" " + _toDisplayString(review.reply), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: `${_unref(mallProductPath)(review.productCode)}?tab=review`
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" 상품에서 보기 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
              }), 128))
            ]))
  ]))
}
}

})